import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useConnectModal from 'components/ConnectModal';
import { useSelector } from 'react-redux';

export default function EmptyCalendar() {
  const {
    setConnectModalOpen,
    setRedirectPath,
    ConnectModal,
  } = useConnectModal();
  const { personas, integrationsEnabled } = useSelector(state => state.global.userInfo);
  const { integratedStatus } = personas;

  function handleClick() {
    setConnectModalOpen(true);
    setRedirectPath(`${document.location.pathname}`);
  }

  return (
    <div className="empty-calendar">
      <FontAwesomeIcon icon={['fal', 'calendar-alt']} />
      {integrationsEnabled && integratedStatus !== 'connected' && (
        <>
          <p>
            Power up your Aisle Planner Pro account with email integration.
            Two-way external calendar sync and easy-to-use scheduling tools, all behind one powerful integration.
          </p>
          <>
            <button
              onClick={handleClick}
              className="button--landing"
            >
              Get Connected
            </button>
            <ConnectModal />
          </>
        </>
      )}
      {!integrationsEnabled && (
        <p>
          This feature is powered by AP Connect, but it looks like you haven't been enabled yet.
          Please contact your account owner to request access. Once enabled, come back here to get connected.
        </p>
      )}
      {integratedStatus === 'connected' && (
        <p>No upcoming events.</p>
      )}
    </div>
  );
};
